export const PAGE_SIZE = 1024;
export const VIEW_TEXT = 1;
export const VIEW_HEX = 2;

// the following constants must be equal corresponding constants in constants.scss:
export const ROW_SIZE_1 = 24; // $rowSize1
export const ROW_SIZE_2 = 16; // $rowSize2
export const ROW_SIZE_3 = 8; // $rowSize3
export const ROW_SIZE_4 = 6; // $rowSize4
export const SCREEN_SIZE_1 = 1200; // $screenSize1
export const SCREEN_SIZE_2 = 800; // $screenSize2
export const SCREEN_SIZE_3 = 450; // $screenSize3
export const VIEW_ITEM_HEIGHT = 20; // $viewItemHeight
export const ROWS_GAP = 5; // $rowsGap

export const FILE_DUMP_EXAMPLE = [0x54, 0x68, 0x69, 0x73, 0x20, 0x69, 0x73, 0x20, 0x61, 0x6e, 0x20, 0x65, 0x78, 0x61, 0x6d, 0x70, 0x6c, 0x65, 0x20, 0x6f, 0x66, 0x20, 0x66, 0x69, 0x6c, 0x65, 0x20, 0x77, 0x69, 0x74, 0x68, 0x20, 0x55, 0x6e, 0x69, 0x63, 0x6f, 0x64, 0x65, 0x20, 0x65, 0x6e, 0x63, 0x6f, 0x64, 0x69, 0x6e, 0x67, 0x2e, 0x0a, 0xd0, 0xad, 0xd1, 0x82, 0xd0, 0xbe, 0x20, 0xd0, 0xbf, 0xd1, 0x80, 0xd0, 0xb8, 0xd0, 0xbc, 0xd0, 0xb5, 0xd1, 0x80, 0x20, 0xd1, 0x84, 0xd0, 0xb0, 0xd0, 0xb9, 0xd0, 0xbb, 0xd0, 0xb0, 0x20, 0xd1, 0x81, 0x20, 0xd0, 0xba, 0xd0, 0xbe, 0xd0, 0xb4, 0xd0, 0xb8, 0xd1, 0x80, 0xd0, 0xbe, 0xd0, 0xb2, 0xd0, 0xba, 0xd0, 0xbe, 0xd0, 0xb9, 0x20, 0xd0, 0xae, 0xd0, 0xbd, 0xd0, 0xb8, 0xd0, 0xba, 0xd0, 0xbe, 0xd0, 0xb4, 0x2e, 0x0a];
